import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-reset-password-dialog',
  templateUrl: './reset-password-dialog.component.html',
  styleUrls: ['./reset-password-dialog.component.css']
})
export class ResetPasswordDialogComponent implements OnInit {

  appearance = 'fill';

  error: boolean = false;

  formGroup: FormGroup;

  constructor(
    private _dialogRef: MatDialogRef<ResetPasswordDialogComponent>,
    private _formBuilder: FormBuilder
  ) {
    this.formGroup = this._formBuilder.group({
      'userName': null,
      'email': null
    });
  }

  confirm(){
    this._dialogRef.close(this.formGroup.value);
  }

  close = () => this._dialogRef.close(false);

  ngOnInit(): void {
  }

}
